export const useTranslations = () => ({
    t: (key) => Dictionary.translate(key),
});
